import axios from "axios";

import type { RequestPerHourReportApiResponse } from "../shared/interface/Report/requestPerHourReport.interface";
import type { ParkingHistoryReportResponse } from "../shared/interface/Report/allUsersReport.interface";
import type { TotalBookingRetrievalCountApiResponse } from "../shared/interface/Report/totalBookingAndRetrieval.interface";
import { IotHubLogsResponse } from "../shared/interface/Report/iotHubLogs.interface";
import { ParamsObject } from "../shared/interface/parking.interface";

export const getVisitorsReport = async (params: { fromDate?: string | null; toDate?: string | null; customerId: number; locationId: number }) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/report/visitors-report/${params.customerId}/${params?.locationId}`;

    const queryParams: string[] = [];

    if (params.fromDate) {
      queryParams.push(`fromDate=${params.fromDate}`);
    }

    if (params.toDate) {
      queryParams.push(`toDate=${params.toDate}`);
    }

    if (queryParams.length > 0) {
      query += `?${queryParams.join("&")}`;
    }

    const res = await axios.get(query);

    return res.data as ParkingHistoryReportResponse;
  } catch (error) {
    throw error;
  }
};

export const getRequestPerHourReport = async (params: { date: string; customerId: number; locationId: number }) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/report/request-per-hour-report/${params.customerId}/${params.locationId}?date=${params.date}`;

    const res = await axios.get(query);

    return res.data as RequestPerHourReportApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getAllUsersReport = async (params: { fromDate?: string | null; toDate?: string | null; customerId: number; locationId: number }) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/report/parking/${params.customerId}/${params.locationId}`;

    const queryParams: string[] = [];

    if (params.fromDate) {
      queryParams.push(`fromDate=${params.fromDate}`);
    }

    if (params.toDate) {
      queryParams.push(`toDate=${params.toDate}`);
    }

    if (queryParams.length > 0) {
      query += `?${queryParams.join("&")}`;
    }

    const res = await axios.get(query);

    return res.data as ParkingHistoryReportResponse;
  } catch (error) {
    throw error;
  }
};

export const getTotalBookingRetrievalCount = async (params: { fromDate: string | undefined | null; toDate: string | undefined | null; customerId: number; locationId: number }) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/report/total-booking-retrieval-count/${params.customerId}/${params.locationId}`;

    const queryParams: string[] = [];

    if (params.fromDate) {
      queryParams.push(`fromDate=${params.fromDate}`);
    }

    if (params.toDate) {
      queryParams.push(`toDate=${params.toDate}`);
    }

    if (queryParams.length > 0) {
      query += `?${queryParams.join("&")}`;
    }

    const res = await axios.get(query);

    return res.data as TotalBookingRetrievalCountApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getIotHubLogs = async (params: ParamsObject) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/report/iotHub-logs/${params.customerId}/${params?.locationId}?page=${params.page}&pageSize=${params.pageSize}&syncDirection=${params.syncDirection}`;

    if (params.fromDate) {
      query += `&fromDate=${params.fromDate}`;
    }

    if (params.toDate) {
      query += `&toDate=${params.toDate}`;
    }

    const res = await axios.get(query);

    return res.data as IotHubLogsResponse;
  } catch (error) {
    throw error;
  }
};
